<template>
	<div class="v5-alert" :class="className">
		<x-dialog v-model="show" :isLockScroll="isLockScroll">
			<div class="v5-alert-content">
				<strong class="v5-alert-title" v-html="title"></strong>
				<div class="v5-alert-message" v-if="text" v-html="text">
				</div>
				<div class="v5-alert-message" v-else>
					<slot></slot>
				</div>
				<x-button class="v5-alert-btn" @on-click="confirm" activeColor="#ccc">
					{{buttonText}}
				</x-button>
			</div>
		</x-dialog>
	</div>
</template>
<script>
	import XDialog from './../x-dialog';
	import XButton from './../x-button';
	export default {
		name: 'v5-alert',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			text: {
				type: String
			},
			title: {
				type: String,
				default: '提示'
			},
			buttonText: {
				type: String,
				default: '确定'
			},
			isLockScroll: {
				type: Boolean,
				default: true
			},
			className: {
				type: String,
				default: ''
			}
		},
		components: {
			XDialog,
			XButton
		},
		watch: {
			value(val) {
				this.show = val;
			},
			show(val) {
				this.$emit('input', val);
			}
		},
		methods: {
			confirm() {
				this.show = false;
				this.$emit('on-confirm');
			}
		},
		data() {
			return {
				show: this.value
			};
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>
